// Import controller interfaces
import {
    IEndorsementPolicyEntityController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import enumerations.
import {
    EndorsementEntityType,
} from '@app/enumerations';
// Import api models.
import {
    BuildingRequestCommercial,
    BuildingRequestCommercialExisting,
    MortgageeRequest,
} from '@app/models/api';

export default class MockEndorsementPolicyEntityController implements IEndorsementPolicyEntityController {

    public constructor() {

    }

    public async addMortgageeForEndorsement(endorsementId: number, mortgagee: MortgageeRequest): Promise<string> {
        throw new Error('Method not implemented.');
    }

    public async updateMortgageeForEndorsement(endorsementId: number, mortgageeGuid: string, mortgagee: MortgageeRequest): Promise<number> {
        throw new Error('Method not implemented.');
    }

    public async addBuildingForEndorsement(endorsementId: number, building: BuildingRequestCommercial): Promise<string> {
        throw new Error('Method not implemented.');
    }

    public async updateBuildingForEndorsement(endorsementId: number, building: BuildingRequestCommercialExisting): Promise<number> {
        throw new Error('Method not implemented.');
    }

    public async removeEntityForEndorsement(endorsementId: number, entityType: EndorsementEntityType, entityId: string): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

    public async reinstateEntityForEndorsement(endorsementId: number, entityType: EndorsementEntityType, entityId: string): Promise<boolean> {
        throw new Error('Method not implemented.');
    }
}